import axios from '../../api/axios';
import { showSuccess, showError } from '../../Components/reuse/Toast';
import { validateToken } from './validateAction';

// Action Types
export const SAVE_REDO_CONFIG_REQUEST = 'SAVE_REDO_CONFIG_REQUEST';
export const SAVE_REDO_CONFIG_SUCCESS = 'SAVE_REDO_CONFIG_SUCCESS';
export const SAVE_REDO_CONFIG_FAILURE = 'SAVE_REDO_CONFIG_FAILURE';


// Action Creators
export const saveRedoConfigRequest = () => ({
  type: SAVE_REDO_CONFIG_REQUEST
});

export const saveRedoConfigSuccess = (data) => ({
  type: SAVE_REDO_CONFIG_SUCCESS,
  payload: data
});

export const saveRedoConfigFailure = (error) => ({
  type: SAVE_REDO_CONFIG_FAILURE,
  payload: error
});

export const saveRedoConfig = (configData) => {
  return async (dispatch) => {
    dispatch(saveRedoConfigRequest());
    
    try {
      const response = await axios.post('redo/redoConfig', configData);
      
      // Show success message from API response
      showSuccess(response.data.message);
      
      // Update auth data to reflect the new configuration
      dispatch(validateToken());
      
      dispatch(saveRedoConfigSuccess(response.data));
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to save Redo configuration';
      showError(errorMessage);
      dispatch(saveRedoConfigFailure(errorMessage));
    }
  };
};

